export default "__VITE_ASSET__0746bd04__"